export function getLastArrayItem<T>(a: T[]): T {
    const [lastItem] = a.slice(-1);

    return lastItem;
}
